import { requestGet } from '@/utils/request';

// 获取学习节点
export function getStudyNode(signUpId: string) {
  return requestGet(`/v2/camp/api/details/index/study/node/${signUpId}`, {});
}

// 展示打卡记录 批次
export function getShowLog(batchId: string) {
  return requestGet(`/v2/camp/api/details/index/log/show/${batchId}`, {});
}

// 展示打卡记录 全部
export function getShowLogAll(campId: string) {
  return requestGet(`/v2/camp/api/details/index/log/show/all/${campId}`, {});
}

// 排名
export function getRanking(batchId: string, campId: string) {
  return requestGet(`/v2/camp/api/details/index/ranking/${batchId}?campId=${campId}`, {});
}
